import * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import MaterialTable from 'material-table'
import { UserContext } from '../../App'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getApiUrl } from '../../api/api'

const columns = [
  { title: 'Referat', field: 'department' },
  { title: 'Semester', field: 'semester' },
  { title: 'Name', field: 'tenantName' },
  {
    title: 'Email',
    field: 'tenantEmail',
    render: (rowData) => <a href={`mailto:${rowData.tenantEmail}`}> {rowData.tenantEmail} </a>,
  },
  { title: 'Zimmer', field: 'tenantRoom' },
  { title: 'Flur', field: 'tenantFloor' },
  { title: 'Punkte', field: 'points', customSort: (a, b) => parseFloat(a.points) - parseFloat(b.points) },
  { title: 'Entlastet', field: 'compensate', type: 'boolean' },
  { title: 'Notiz', field: 'note' },
]

export default function HeimratEngagements() {
  const [engagements, setEngagements] = useState(null)
  const { user } = useContext(UserContext)

  const [proceeding, setProceeding] = useState(true)

  useEffect(() => {
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }
    setProceeding(true)
    getApiUrl()
      .get(`/api/engagements`)
      .then(function(response) {
        setProceeding(false)
        setEngagements(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [user.token])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={engagements != null ? engagements : []}
          title="Ausgeübte Referate und Ämter"
          options={{
            pageSize: 30,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
          }}
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            header: {
              actions: 'Aktion',
            },
            body: {
              emptyDataSourceMessage: 'Keine Daten vorhanden.',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
    </GridContainer>
  )
}
